import Vue from 'vue';
import ProductCategoryTabs from './ProductCategoryTabs';


Vue.component('brku-product-category-tabs', ProductCategoryTabs);